import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { eraseRULotDataFromStore } from '../../../../store/actions/RU/creationLotActions';
import Dialog from '@material-ui/core/Dialog';
import RULotSummary from './RULotSummary';


class RULotEditForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClose() {
    this.props.openEditLotMainForm();
    this.props.eraseRULotDataFromStore();
    this.props.reloadNegotiationLotsTableList();
  };


  render() {

    return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={this.handleClose.bind(this)}
      >
        <RULotSummary
          handleClose={this.handleClose.bind(this)}
          showContent={this.props.showContent}
          reloadTable={() => this.props.reloadNegotiationLotsTableList()}
        />
      </Dialog>
    );
  }
}

RULotEditForm.propTypes = {
  openEditLotMainForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => ({
  eraseRULotDataFromStore: () => dispatch(eraseRULotDataFromStore())
});

export default connect(mapStateToProps, mapDispatchToProps)(RULotEditForm);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsEditLots/RULotEditForm.js